(() => {
    /**
     * Fetches strava state
     * @param stravaUrl
     */
    function fetchStrava(stravaUrl) {
        const request = new XMLHttpRequest();
        request.open('GET', stravaUrl, true);

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                const data = JSON.parse(request.responseText);
                const loading = document.getElementById('strava-loading-button');
                loading.classList.add('d-none');
                if (data.connected) {
                    document.getElementById('strava-connected-button').classList.remove('d-none');
                    document.getElementById('strava-connected').classList.remove('d-none');
                } else {
                    document.getElementById('strava-disconnected-button').classList.remove('d-none');
                    document.getElementById('strava-disconnected').classList.remove('d-none');
                }
            }
        };

        request.send();
    }

    const stravaButtonElement = document.getElementById('strava-loading-button');
    if (stravaButtonElement) {
        fetchStrava('/account/strava/account');
    }
})();
